import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: window.navigator.userLanguage || window.navigator.language,
    fallbackLocale: "en",
    silentFallbackWarn: process.env.NODE_ENV === "production",
    messages: require("./locales/index").default
});

export default i18n;
